module.exports = __webpack_public_path__ + "images/85b67a2dc301864843b34eabc3480ac9.png";